<td
  (mouseenter)="onMouseEnter($event)"
  (mouseleave)="onMouseLeave($event)"
  [style.color]="background"
  [ngClass]="{ highlight: highlight }"
>
  {{ val | percentage }}
</td>
